import React from 'react';
import { parseNumber } from 'utils/parser';
import { getUomTypesAbbreviations } from '../DailyValueConstants';
import { useGetBasicUomEnum } from 'hooks';
import SeparatorBar from './SeparatorBar';

function NutrientSideBySide({ index, nutrient }) {
  const { basicUomProperties } = useGetBasicUomEnum();

  const {
    nutritionName,
    quantity,
    quantityUom,
    dailyValueIntakePercent,
    hightLightText,
  } = nutrient ?? {};

  const gram = `${parseNumber(quantity)}${getUomTypesAbbreviations(
    basicUomProperties,
    quantityUom
  )}`;
  const percent = parseNumber(dailyValueIntakePercent);
  const showDot = index % 2 === 0;

  const styles = {
    indent: {
      backgroundColor: hightLightText,
    },
  };

  return (
    <>
      <div className='nutrition-facts__vitamin' style={styles.indent}>
        {showDot && <span>•</span>}
        <div>
          {nutritionName} {gram} {`${percent || 0}%`}
        </div>
      </div>
      <SeparatorBar indentBar={0} />
    </>
  );
}

export default NutrientSideBySide;
